import Layout from "../components/Layout/HomePage/Layout"
import TestScreen from "../components/Matrixpage/TestScreen"
export default function MatrixPage(){
    return(
        <Layout>            
            <TestScreen />
        </Layout>
    )
}